<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/Text/pre2">Series preface</a></div>
<div class="SOM_pre"><a href="#/Text/pre3">Preface</a></div>
<div class="SOM_pre"><a href="#/Text/pre4">Abbreviations</a></div>
<div class="SOM_chap_tit"><a href="#/Text/chap1">1. In the beginning: human marriage as ‘one flesh’</a></div>
<div class="SOM_chap"><a href="#/Text/chap2">2. Playing the harlot</a></div>
<div class="SOM_chap"><span href="#/Text/chap3" title="Link target outside of Sample">3. Committing great harlotry</span></div>
<div class="SOM_chap"><span href="#/Text/chap4" title="Link target outside of Sample">4. Under every green tree</span></div>
<div class="SOM_chap"><span href="#/Text/chap5" title="Link target outside of Sample">5. In every public square</span></div>
<div class="SOM_chap"><span href="#/Text/chap6" title="Link target outside of Sample">6. The ultimate marriage as ‘one spirit’</span></div>
<div class="SOM_chap"><span href="#/Text/chap7" title="Link target outside of Sample">7. Concluding reflections</span></div>
<div class="SOM_appen_tit"><span href="#/Text/appen6" title="Link target outside of Sample">Appendix: The harlot metaphor and feminist interpretation</span></div>
<div class="SOM_appen"><span href="#/Text/appen7" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/Text/appen8" title="Link target outside of Sample">Index of Scripture references</span></div>
<div class="SOM_appen"><span href="#/Text/appen9" title="Link target outside of Sample">Index of authors</span></div>
<div class="SOM_appen"><span href="#/Text/appen10" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/Text/appen11" title="Link target outside of Sample">Praise for <i>God’s Unfaithful Wife</i></span></div>
<div class="SOM_appen"><span href="#/Text/appen12" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/Text/ident12#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?81a0489c